module.exports = __webpack_public_path__ + "mobile-contact-header-img.49648024.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Contact/mobile-contact-header-img.jpg
// module id = 613
// module chunks = 0